export default __webpack_public_path__ + "static/media/navbar-incoming-messages-orange.fe80b50d.svg";